import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  NegotiationDto,
  NegotiationProposalDto,
  NegotiationProposalReferenceDto,
  NegotiationReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import NegotiationInline, { NegotiationInlineProps } from "./NegotiationInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: NegotiationDto | NegotiationReferenceDto | null | undefined;
  entityId?: string | null;
  proposal?: NegotiationProposalDto | NegotiationProposalReferenceDto;
  proposalId?: string | null;
  inlineProps?: Partial<NegotiationInlineProps>;
}

export default function NegotiationLink({
  entity,
  entityId,
  proposal,
  proposalId,
  inlineProps,
  ...otherProps
}: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.NegotiationRead]}
      to={ROUTE_PATH.NEGOTIATION_VIEW(entity?.id || entityId || "")}
      content={
        <NegotiationInline
          entity={entity}
          entityId={entityId}
          proposal={proposal}
          proposalId={proposalId}
          {...inlineProps}
        />
      }
      {...otherProps}
    />
  );
}
